import { render, staticRenderFns } from "./RemissionPreview.vue?vue&type=template&id=6a502304&scoped=true&"
import script from "./RemissionPreview.vue?vue&type=script&lang=js&"
export * from "./RemissionPreview.vue?vue&type=script&lang=js&"
import style0 from "./RemissionPreview.vue?vue&type=style&index=0&id=6a502304&prod&lang=scss&scoped=true&"
import style1 from "./RemissionPreview.vue?vue&type=style&index=1&id=6a502304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a502304",
  null
  
)

export default component.exports